import { render } from "./SimpleUiAnnouncementDialog.vue?vue&type=template&id=7f3107cd&ts=true"
import script from "./SimpleUiAnnouncementDialog.vue?vue&type=script&lang=ts"
export * from "./SimpleUiAnnouncementDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__